/** From Flutter `app_de.arb` — privacyPolicy* / termsOfService*, updated structure. */
export const legalMessagesDe = {
  privacy: {
    pageTitle: "Datenschutzerklärung",
    lastUpdated: "Letzte Aktualisierung: 1. Juni 2026",
    introduction: {
      title: "Einführung",
      body: "WasOK ist eine lokale Hilfs‑App beim Einkaufen. Sie soll Nutzerinnen und Nutzern helfen, sich an Produkte zu erinnern, die sie zuvor gekauft, bewertet oder rezensiert haben.\n\nIn dieser Datenschutzerklärung erfahren Sie, welche Daten bei Nutzung der App verarbeitet werden, wie sie gespeichert werden und wie bestimmte Drittanbieter‑Dienste arbeiten können.",
    },
    dataStored: {
      title: "Daten, die durch die App gespeichert werden",
      body: "WasOK speichert folgende Angaben nur lokal auf Ihrem Gerät:\n\n• gescannte Produkt‑Barcodes\n• Namen und Details von Produkten, die Sie eingeben\n• Bewertungen und Kommentare\n• Einkaufslisten\n• Produktkategorien\n• Preise und Geschäftsinformationen\n• Produkt‑ und Geschäftsfotos\n\nIhre Produktdaten und Fotos werden nicht auf die Server von WasOK hochgeladen.",
    },
    permissions: {
      title: "Verwendete Berechtigungen",
      camera: {
        title: "Kamera",
        body: "Der Kamerazugriff wird genutzt für:\n\n• Barcodes scannen\n• Fotos von Produkten aufnehmen",
      },
      photos: {
        title: "Fotos und Medien",
        body: "Zugriff auf Fotos oder die Galerie wird nur genutzt, wenn:\n\n• Sie Bilder zu Produkten hinzufügen\n• Sie Backups wiederherstellen, die Fotos enthalten",
      },
      files: {
        title: "Dateizugriff und Speicher",
        body: "Dateizugriff kann genutzt werden für:\n\n• Export von Backup‑Dateien\n• Import von vom Nutzer gewählten Backups\n• Teilen von Einkaufslisten oder Backups",
      },
    },
    backup: {
      title: "Backup und Export",
      body: "Mit WasOK können Sie Backup‑Dateien mit App‑Daten und optional Fotos erstellen.\n\nBackup‑Dateien werden lokal auf Ihrem Gerät erzeugt und können über von Ihnen gewählte Dienste gespeichert oder geteilt werden, z.\u202fB.:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• lokaler Gerätespeicher\n\nWasOK lädt Backups nicht auf eigene Server hoch.",
      onlineProductLookup: {
        title: "Online-Produktsuche",
        body: "Wenn Sie die Online-Barcode-Suche in den Einstellungen aktivieren, kann WasOK nur die gescannte Barcode-Nummer an öffentliche Produktdatenbanken (z. B. Open Food Facts) senden, um Name und Marke vorzuschlagen. WasOK lädt dabei keine Bewertungen, Kommentare, Fotos, Einkaufslisten, Kategorien, Geschäftsdaten oder Backups hoch. Sie können dies jederzeit in den Einstellungen deaktivieren.",
      },
    },
    advertising: {
      title: "Werbung und Drittanbieter‑Dienste",
      intro:
        "WasOK nutzt ausgewählte Drittanbieter‑Dienste, um bestimmte Funktionen bereitzustellen.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob wird genutzt, um Werbung in der App anzuzeigen.\n\nGoogle und seine Partner können Informationen verarbeiten wie:\n\n• Werbekennungen\n• Geräteinformationen\n• IP‑Adresse\n• Diagnose‑ und Nutzungsdaten\n\nIn einigen Regionen kann vor der Anzeige personalisierter Werbung eine Einwilligung erforderlich sein.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK nutzt Firebase Crashlytics, um Abstürze zu erkennen und die App‑Stabilität zu verbessern.\n\nAbsturzberichte können technische Informationen enthalten wie:\n\n• Gerätemodell\n• Betriebssystemversion\n• App‑Version\n• Absturzdiagnosen\n\nAbsturzberichte enthalten absichtlich nicht Ihre Produktbewertungen, Notizen, Einkaufslisten oder Fotos.",
      },
      externalProductDatabases: {
        title: "Externe Produktdatenbanken",
        body: "Die Barcode‑Suchfunktion kann externe Produktdatenbanken nutzen, um Produktinformationen abzurufen.\n\nWeitere Informationen finden Sie in den Datenschutzerklärungen der jeweiligen Anbieter.",
      },
    },
    dataSecurity: {
      title: "Datensicherheit",
      body: "WasOK speichert App‑Daten lokal auf Ihrem Gerät mithilfe der Speichermechanismen des Betriebssystems.\n\nObwohl zum Schutz Ihrer lokalen App‑Daten angemessene Maßnahmen ergriffen werden, ist kein elektronisches Speicherverfahren völlig sicher.\n\nSie sind selbst dafür verantwortlich, wichtige Daten bei Bedarf zu sichern.",
    },
    children: {
      title: "Datenschutz von Kindern",
      body: "WasOK richtet sich nicht an Kinder unter 13 Jahren.",
    },
    notifications: {
      title: "Benachrichtigungen",
      body: "WasOK kann optional lokale Benachrichtigungen auf Ihrem Gerät erstellen, die Sie daran erinnern, Produkte nach dem Kauf zu bewerten.\n\nDiese Benachrichtigungen werden lokal auf Ihrem Gerät erzeugt und geplant und erfordern kein Konto oder einen Remote‑Server.\n\nSie können Benachrichtigungen jederzeit in den Geräteeinstellungen oder in der App deaktivieren, sofern unterstützt.",
    },
    yourControl: {
      title: "Ihre Kontrolle über die Daten",
      body: "Sie können:\n\n• gespeicherte Produkte jederzeit bearbeiten oder löschen\n• App‑Daten auf Ihrem Gerät löschen\n• die App deinstallieren\n• Backups Ihrer Daten exportieren",
    },
    changes: {
      title: "Änderungen an dieser Erklärung",
      body: "Diese Datenschutzerklärung kann regelmäßig aktualisiert werden.\n\nÄnderungen gelten mit Veröffentlichung der aktualisierten Fassung.",
    },
    contact: {
      title: "Kontakt",
      body: "Bei Fragen zu dieser Datenschutzerklärung wenden Sie sich an:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Nutzungsbedingungen",
    lastUpdated: "Letzte Aktualisierung: 1. Juni 2026",
    acceptance: {
      title: "Akzeptanz der Bedingungen",
      body: "Durch das Herunterladen, Installieren oder Nutzen von WasOK erklären Sie sich mit diesen Nutzungsbedingungen einverstanden.\n\nWenn Sie diesen Bedingungen nicht zustimmen, dürfen Sie die App nicht nutzen.",
    },
    license: {
      title: "Lizenz",
      body: "WasOK gewährt Ihnen eine eingeschränkte, nicht ausschließliche, nicht übertragbare und widerrufliche Lizenz zur Nutzung der App gemäß diesen Bedingungen.",
    },
    acceptableUse: {
      title: "Zulässige Nutzung",
      body: "Sie erklären, Folgendes zu unterlassen:\n\n• Missbrauch der App\n• Störungen des App‑Betriebs\n• Versuche des Reverse Engineerings oder der Veränderung der App\n• Nutzung der App unter Verstoß gegen geltendes Recht oder Vorschriften",
    },
    localData: {
      title: "Lokale Daten und Backups",
      body: "WasOK speichert Nutzerdaten lokal auf dem Gerät.\n\nSie sind selbst für die Pflege sicherungswichtiger Daten verantwortlich, wenn Sie dies wünschen.\n\nBackup‑ und Wiederherstellungsfunktionen können vorhanden sein; WasOK übernimmt jedoch keine Gewähr gegen Verlust, Beschädigung oder Ausfall gespeicherter Daten.",
    },
    advertisements: {
      title: "Werbung",
      body: "In der App kann Werbung angezeigt werden, die von Dritt‑Anzeigenpartnern bereitgestellt wird, darunter Google AdMob.",
    },
    noWarranty: {
      title: "Keine Gewähr",
      body: "WasOK wird „wie besehen“ und „nach Verfügbarkeit“ ohne Gewährleistungen jeglicher Art, weder ausdrücklich noch stillschweigend, bereitgestellt.\n\nWir garantieren nicht:\n\n• dass die App stets verfügbar ist\n• dass die App fehlerfrei ist\n• dass es nie zu Datenverlust kommt\n• dass alle Funktionen auf allen Geräten ohne Unterbrechungen laufen",
    },
    limitationLiability: {
      title: "Haftungsbeschränkung",
      body: "Im gesetzlich zulässigen Höchstmaß haften WasOK und die Entwickler nicht für:\n\n• Datenverlust\n• Gewinnausfälle\n• Geräteprobleme\n• indirekte oder Folgeschäden\n• Unterbrechungen durch Nutzung oder Nichtnutzung der App",
    },
    thirdParty: {
      title: "Drittanbieter‑Dienste",
      body: "Bestimmte Funktionen oder Inhalte können von Drittanbieter‑Diensten abhängen, z.\u202fB. Anzeigenanbietern und externen Speicher‑ oder Freigabediensten, die Sie auswählen.\n\nWasOK ist nicht verantwortlich für Drittanbieter‑Dienste oder deren Richtlinien.",
    },
    productInformation: {
      title: "Produktinformationen",
      body: "Bestimmte Produktdetails können über Drittanbieter‑Barcode‑Suchdienste abgerufen werden.\n\nWasOK übernimmt keine Gewähr für Richtigkeit, Vollständigkeit, Verfügbarkeit oder Eignung von Informationen externer Datenquellen.\n\nNutzer sollten Produktinformationen bei Bedarf selbst überprüfen.",
    },
    changesApp: {
      title: "Änderungen an der App",
      body: "WasOK kann jederzeit ohne vorherige Ankündigung geändert, aktualisiert, ausgesetzt oder eingestellt werden.",
    },
    changesTerms: {
      title: "Änderungen dieser Bedingungen",
      body: "Diese Bedingungen können regelmäßig aktualisiert werden.\n\nDie fortgesetzte Nutzung der App nach Inkrafttreten von Änderungen gilt als Annahme der überarbeiteten Bedingungen.",
    },
    contact: {
      title: "Kontakt",
      body: "Bei Fragen zu diesen Bedingungen wenden Sie sich an:\n\nsupport@wasok.app",
    },
  },
};
